import { FC } from "react";
import { Table } from "taltech-styleguide";

type Props = {
  tableItems: any[];
  filterPredicate: (item: any) => boolean;
};

export const SimpleTable: FC<Props> = ({ tableItems, filterPredicate }) => {
  return (
    <div style={{ maxHeight: "300px", height: "300px", overflow: "auto" }}>
      <Table>
        <thead>
          <tr>
            <th>Course</th>
            <th>Start date</th>
            <th>End date</th>
          </tr>
        </thead>
        <tbody>
          {tableItems.filter(filterPredicate).length === 0 ? (
            <tr>
              <td
                colSpan={3}
                className="text-center"
                style={{ border: "none" }}
              >
                No data
              </td>
            </tr>
          ) : (
            tableItems.filter(filterPredicate).map((data) => (
              <tr key={data.courseName}>
                <td>{data.courseName}</td>
                <td>{data.startDate.toString()}</td>
                <td>{data.endDate.toString()}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};
